import React from 'react';

const Cookies = () => {
  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <div className="shadow-md rounded-2xl p-8 max-w-4xl bg-[#112D4E]">
        <h1 className="text-3xl font-bold mb-6 text-center text-[#19BFB7]">
          Cookie Policy
        </h1>
        <p className="text-white text-center mb-4">Effective Date: 2025</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">1. Introduction</h2>
          <p className="text-white">
            AIAURA ("Company," "we," "our," or "us") uses cookies and similar tracking technologies on our website to enhance user experience, improve our services, and ensure security. This Cookie Policy explains what cookies are, how we use them, and how users can manage their preferences.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">2. What Are Cookies?</h2>
          <p className="text-white">
            Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, track website usage, and enhance functionality. Cookies can be "session cookies" (deleted when you close your browser) or "persistent cookies" (remain on your device until deleted or expired).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">3. Types of Cookies We Use</h2>
          <ul className="list-disc list-inside text-white ml-4">
            <li><span className="font-semibold text-[#19BFB7]">Strictly Necessary Cookies</span> – Essential for website functionality, security, and accessibility. These cookies cannot be disabled.</li>
            <li><span className="font-semibold text-[#19BFB7]">Performance Cookies</span> – Collect anonymous data on website usage to improve functionality and user experience.</li>
            <li><span className="font-semibold text-[#19BFB7]">Functionality Cookies</span> – Remember user preferences to provide a more personalized experience.</li>
            <li><span className="font-semibold text-[#19BFB7]">Targeting/Advertising Cookies</span> – Track user activity to deliver relevant advertisements.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">4. Third-Party Cookies</h2>
          <p className="text-white">
            We may allow third-party service providers (e.g., analytics and advertising partners) to place cookies on our website. These third parties may collect data to analyze website traffic and deliver targeted ads. We do not control these cookies and recommend reviewing their respective privacy policies.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">5. Managing Cookie Preferences</h2>
          <p className="text-white">
            Users can manage their cookie preferences through browser settings or our cookie consent banner. Most browsers allow users to block or delete cookies; however, restricting certain cookies may impact website functionality.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">6. Updates to This Policy</h2>
          <p className="text-white">
            We may update this Cookie Policy to reflect changes in our practices or legal requirements. Any updates will be posted on our website with an updated "Effective Date."
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#19BFB7]">7. Contact Information</h2>
          <p className="text-white">
            For questions regarding this Cookie Policy, please contact us at <a href="mailto:admin@aiaura.co.uk" className="text-[#19BFB7] hover:underline">admin@aiaura.co.uk</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Cookies;
